"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _spauiUtils = require("@tencent/spaui-utils");

var _spauiSelect = _interopRequireDefault(require("@tencent/spaui-select"));

var _classnames = _interopRequireDefault(require("classnames"));

var _ValueAreaComponent = _interopRequireDefault(require("./component/ValueAreaComponent"));

var _SelectionDataComponent = _interopRequireDefault(require("./component/SelectionDataComponent"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var isFunction = _spauiUtils.utils.isFunction,
    isArray = _spauiUtils.utils.isArray;
var defaultFieldNames = _spauiUtils.nodeTree.defaultFieldNames;
/**
 * @class
 */

var SelectTree =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(SelectTree, _PureComponent);

  /**
   * 属性说明
   * @alias SelectTreeProps
   * @property {array} data=[] 数据
   * @property {array|string|number} value='' 选中的数据
   * @property {func} onChange 数据回调
   * @property {func} [setValueLabel] 设置选中值的展示文案(valueAreaType不为labels有效) setValueLabel=(value, valueTreeNodeMap)
   * @property {bool} [showParentNodeLabel=true] 选中数据展示的文案是否需要父节点的文案
   * @property {string} [placeholder='请选择'] 没有选择数据时的提示文案
   * @property {bool} [multiple=false] 是否多选
   * @property {bool} [disabled=false] 是否禁用
   * @property {string} [delimiter='/'] 分隔符
   * @property {string} [valueDelimiter=', '] 多数据时的分隔符
   * @property {object} [dropStyle={}] 下拉框面板的样式
   * @property {bool} [unrelated=false] 是否父子节点不关联
   * @property {bool} [isAutoCheckedParent=true] 子节点全选时自动选上父节点, 并从checkedIds删除子节点
   * @property {func} [setNodeClassName] 设置每一选项的className*setNodeClassName=(treeData) => return string*
   * @property {func} [setBranchTitle] 设置每一列的title*setBranchTitle=(index, data, parentData)*
   * @property {string} [branchTitleClassName=''] 设置列title时生效，可用于设置title的className
   * @property {string} [valueType='parent'] 选中的节点 *可选值：parent, child*
   * @property {string} [selectTarget='default'] 选中目标，默认为default即有数据就可选，child就只能选中末端节点 *可选值：default, child*
   * @property {bool} [search=false] 是否搜索
   * @property {string} [searchValue=''] 搜索框数据
   * @property {array} [searchValueData=[]] 搜索后使用方自己提供的选项
   * @property {array} [labelData=[]] 用于匹配value中已不在data里的数据显示
   * @property {func} [onSearch] 搜索回调
   * @property {func} [canSelected] 节点是否能够选中
   * @property {object} [SelectProps={}] Select组件的props
   * @property {object} [TreeProps={}] Tree组件的props
   * @property {string} [valueAreaType='string'] 展示区域类型 *可选值: string, labels*
   * @property {bool} [clear=false] 为labels的时候是否能够清空
   * @property {func} [onColumnScroll] 每列的滚动
   * @property {array} [expandNodeIds] 展开的节点
   * @property {func} [onNodeClick] 点击节点回调
   * @property {array} [loadingIds=[]] 加载中的节点
   * @property {string|object} [mountTarget='component'] 选择面板挂载的目标在哪里 *可选值：component, body*
   * @property {string} [mountTargetClassName=''] 针对mountTarget != 'component'
   * @property {string} [fieldNames={labelFieldName:'desc', valueFieldName: 'value',titleFieldName: 'tips',nodeFieldName: 'options',disabledFieldName: 'disabled'}] 原始数据字段映射
   *
   * @example
   * data = [{
   *      value: 1,
   *      desc: '第一节点',
   *      parent_id: 0,
   *      options: [{
   *          value: 11,
   *          desc: '第二节点',
   *          parent_id: 1,
   *      }]
   * }]
   *
   * onChange = (event, value)
   *
   * canSelected={treeNode, defaultAllowSelected}
   */
  function SelectTree(props) {
    var _this;

    _classCallCheck(this, SelectTree);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SelectTree).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "getDefaultIdLabelData", function () {
      var idLabelData = [];
      var _this$props = _this.props,
          value = _this$props.value,
          data = _this$props.data,
          _this$props$fieldName = _this$props.fieldNames,
          fieldNames = _this$props$fieldName === void 0 ? {} : _this$props$fieldName;
      var labelFieldName = fieldNames.labelFieldName;

      var _nodeTree$genLiteNode = _spauiUtils.nodeTree.genLiteNodeTree(data, {}, undefined, {
        fieldNames: fieldNames
      }),
          valueTreeNodeMap = _nodeTree$genLiteNode.valueTreeNodeMap;

      var theValue = [];

      if (isArray(value)) {
        theValue = value;
      } else {
        theValue = [value];
      }

      theValue.forEach(function (itemValue) {
        if (!(0, _spauiUtils.isEmptyValue)(itemValue)) {
          // 如果 data 中的数据包括了 id 对应的数据，则直接使用这个数据，否则直接使用 id 作为兜底数据
          if (valueTreeNodeMap[itemValue]) {
            idLabelData.push({
              value: itemValue,
              label: valueTreeNodeMap[itemValue][labelFieldName] || itemValue,
              desc: valueTreeNodeMap[itemValue][labelFieldName] || itemValue
            });
          } else {
            idLabelData.push({
              value: itemValue,
              label: itemValue,
              desc: itemValue
            });
          }
        }
      });
      return idLabelData;
    });

    _this.setTreeNodeValue(props);

    _this.handleChange = _this.handleChange.bind(_assertThisInitialized(_this));
    _this.handleClear = _this.handleClear.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(SelectTree, [{
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      this.setTreeNodeValue(nextProps);
    }
  }, {
    key: "getValueLabel",
    value: function getValueLabel() {
      var _this$props2 = this.props,
          data = _this$props2.data,
          delimiter = _this$props2.delimiter,
          value = _this$props2.value,
          multiple = _this$props2.multiple,
          valueDelimiter = _this$props2.valueDelimiter,
          setValueLabel = _this$props2.setValueLabel,
          showParentNodeLabel = _this$props2.showParentNodeLabel,
          fieldNames = _this$props2.fieldNames;

      var _nodeTree$genLiteNode2 = _spauiUtils.nodeTree.genLiteNodeTree(data, {}, undefined, {
        fieldNames: fieldNames
      }),
          valueTreeNodeMap = _nodeTree$genLiteNode2.valueTreeNodeMap;

      var getLabel = function getLabel() {
        var theData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
        var theValueLabelArr = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

        if (theData) {
          if (theData.desc) {
            theValueLabelArr.unshift(theData.desc);
          }

          if (theData.parentNode) {
            getLabel(theData.parentNode, theValueLabelArr);
          }
        }
      };

      var getTheValueLabel = function getTheValueLabel(theValue) {
        var valueData = valueTreeNodeMap[theValue] || null;
        var theValueLabel = '';
        var valueLabelArr = [];

        if (showParentNodeLabel) {
          if (valueData) {
            getLabel(valueData, valueLabelArr);
          }

          if (valueLabelArr.length > 0) {
            theValueLabel = valueLabelArr.join(delimiter);
          }
        } else {
          theValueLabel = valueData && valueData.desc;
        } // 如果value的值在data中没有找到就用value进行展示


        if (!valueData && !theValueLabel && (typeof theValue === 'number' || theValue)) {
          theValueLabel = theValue;
        }

        return theValueLabel;
      };

      var result = '';

      if (multiple) {
        result = [];
        value.map(function (item) {
          var theValueLabel = getTheValueLabel(item);

          if (theValueLabel) {
            result.push(theValueLabel);
          }

          return item;
        });
        result = result.join(valueDelimiter);
      } else {
        result = getTheValueLabel(value);
      }

      if (isFunction(setValueLabel)) {
        result = setValueLabel(value, valueTreeNodeMap);
      }

      return result;
    } // 渲染节点value

  }, {
    key: "setTreeNodeValue",
    value: function setTreeNodeValue() {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var _props$fieldNames = props.fieldNames,
          fieldNames = _props$fieldNames === void 0 ? {} : _props$fieldNames,
          _props$data = props.data,
          data = _props$data === void 0 ? [] : _props$data;
      var _fieldNames$nodeField = fieldNames.nodeFieldName,
          nodeFieldName = _fieldNames$nodeField === void 0 ? 'options' : _fieldNames$nodeField,
          _fieldNames$valueFiel = fieldNames.valueFieldName,
          valueFieldName = _fieldNames$valueFiel === void 0 ? 'value' : _fieldNames$valueFiel,
          _fieldNames$parentFie = fieldNames.parentFieldName,
          parentFieldName = _fieldNames$parentFie === void 0 ? 'parent_id' : _fieldNames$parentFie,
          _fieldNames$labelFiel = fieldNames.labelFieldName,
          labelFieldName = _fieldNames$labelFiel === void 0 ? 'desc' : _fieldNames$labelFiel,
          _fieldNames$disabledF = fieldNames.disabledFieldName,
          disabledFieldName = _fieldNames$disabledF === void 0 ? 'disabled' : _fieldNames$disabledF; // 渲染一层一层结构dom

      var renderTreeLevel = function renderTreeLevel() {
        var levelData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        var level = arguments.length > 1 ? arguments[1] : undefined;

        if (isArray(levelData)) {
          levelData.map(function (item) {
            if (item) {
              if (typeof item[valueFieldName] !== 'undefined' && typeof item.value === 'undefined') {
                item.value = item[valueFieldName];
              }

              if (typeof item[parentFieldName] !== 'undefined' && typeof item.parent_id === 'undefined' && level > 0) {
                item.parent_id = item[parentFieldName];
              }

              if (typeof item[nodeFieldName] !== 'undefined' && typeof item.options === 'undefined') {
                item.options = item[nodeFieldName];
              }

              if (typeof item[labelFieldName] !== 'undefined' && typeof item.desc === 'undefined') {
                item.desc = item[labelFieldName];
              }

              if (typeof item[disabledFieldName] !== 'undefined' && typeof item.disabled === 'undefined') {
                item.disabled = item[disabledFieldName];
              } // 遍历子节点


              if (isArray(item[nodeFieldName]) && item[nodeFieldName].length > 0) {
                renderTreeLevel(item[nodeFieldName], level + 1);
              }
            }

            return item;
          });
        }
      };

      if (isArray(data)) {
        renderTreeLevel(data, 0);
      }
    }
  }, {
    key: "handleChange",
    value: function handleChange(event) {
      var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
      var lastValueNodeMap = arguments.length > 2 ? arguments[2] : undefined;
      var treeNode = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
      var _this$props3 = this.props,
          onChange = _this$props3.onChange,
          multiple = _this$props3.multiple,
          data = _this$props3.data,
          fieldNames = _this$props3.fieldNames;

      var _nodeTree$genLiteNode3 = _spauiUtils.nodeTree.genLiteNodeTree(data, {}, undefined, {
        fieldNames: fieldNames
      }),
          valueTreeNodeMap = _nodeTree$genLiteNode3.valueTreeNodeMap;

      var result = [];
      var useValue = true;
      var resultMap = {};
      var newResult = '';

      if (multiple) {
        value.map(function (item) {
          if (isArray(item) && useValue) {
            useValue = false;
          }

          return item;
        });

        if (!useValue) {
          value.map(function (item) {
            if (isArray(item)) {
              item.map(function (subItem) {
                result.push(subItem);
                return subItem;
              });
            }

            return item;
          });
        } else {
          result = value;
        }
      } else {
        if (isArray(value)) {
          if (typeof value[0] === 'number') {
            result = value[0];
          } else {
            result = value[0] || '';
          }
        } else {
          result = value;
        }
      }

      if (isArray(result)) {
        resultMap = {};
        newResult = [];
        result.map(function (item) {
          // 过滤重复的
          if (typeof resultMap[item] === 'undefined') {
            newResult.push(item);
            resultMap[item] = item;
          }

          return item;
        });
      } else {
        newResult = result;
      }

      if (isFunction(onChange)) {
        onChange(event, newResult, treeNode, valueTreeNodeMap);
      }
    }
    /**
     * 获取默认的 id label 数据
     *
     * @memberof SelectTree
     */

  }, {
    key: "getValueDataMap",
    value: function getValueDataMap() {
      var _this$props4 = this.props,
          data = _this$props4.data,
          value = _this$props4.value,
          labelData = _this$props4.labelData,
          _this$props4$fieldNam = _this$props4.fieldNames,
          fieldNames = _this$props4$fieldNam === void 0 ? {} : _this$props4$fieldNam;
      var labelFieldName = fieldNames.labelFieldName;

      var _nodeTree$genLiteNode4 = _spauiUtils.nodeTree.genLiteNodeTree(data, {}, undefined, {
        fieldNames: fieldNames
      }),
          valueTreeNodeMap = _nodeTree$genLiteNode4.valueTreeNodeMap;

      var getValueAndLabelData = function getValueAndLabelData(theValue) {
        var theData = {};

        if (valueTreeNodeMap[theValue]) {
          theData = {
            value: theValue,
            label: valueTreeNodeMap[theValue][labelFieldName] || theValue
          };
        }

        return theData;
      };

      var result = {};

      if (typeof value === 'number' || value) {
        if (isArray(value)) {
          value.map(function (item) {
            result[item] = getValueAndLabelData(item);
            return item;
          });
        } else {
          result[value] = getValueAndLabelData(value);
        }

        if (isArray(labelData)) {
          var idLabelData = this.getDefaultIdLabelData();
          idLabelData.concat(labelData).map(function () {
            var item = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

            if (item) {
              result[item.value] = _objectSpread({}, item, {
                label: item[labelFieldName] || item.label || ''
              });
            }

            return item;
          });
        }
      }

      return result;
    }
  }, {
    key: "handleClear",
    value: function handleClear(event) {
      var _this$props5 = this.props,
          multiple = _this$props5.multiple,
          onClear = _this$props5.onClear;

      if (isFunction(onClear)) {
        onClear(event);
      } else {
        this.handleChange(event, multiple ? [] : '');
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props6 = this.props,
          placeholder = _this$props6.placeholder,
          ValueAreaComponent = _this$props6.ValueAreaComponent,
          data = _this$props6.data,
          value = _this$props6.value,
          SelectProps = _this$props6.SelectProps,
          TreeProps = _this$props6.TreeProps,
          unrelated = _this$props6.unrelated,
          isAutoCheckedParent = _this$props6.isAutoCheckedParent,
          setNodeClassName = _this$props6.setNodeClassName,
          valueType = _this$props6.valueType,
          selectTarget = _this$props6.selectTarget,
          canSelected = _this$props6.canSelected,
          multiple = _this$props6.multiple,
          disabled = _this$props6.disabled,
          dropStyle = _this$props6.dropStyle,
          valueAreaType = _this$props6.valueAreaType,
          clearable = _this$props6.clearable,
          clear = _this$props6.clear,
          search = _this$props6.search,
          searchValue = _this$props6.searchValue,
          onSearch = _this$props6.onSearch,
          onNodeClick = _this$props6.onNodeClick,
          onColumnScroll = _this$props6.onColumnScroll,
          loadingIds = _this$props6.loadingIds,
          expandNodeIds = _this$props6.expandNodeIds,
          mountTarget = _this$props6.mountTarget,
          mountTargetClassName = _this$props6.mountTargetClassName,
          _this$props6$fieldNam = _this$props6.fieldNames,
          fieldNames = _this$props6$fieldNam === void 0 ? {} : _this$props6$fieldNam,
          propsSearchValueData = _this$props6.searchValueData,
          setBranchTitle = _this$props6.setBranchTitle,
          branchTitleClassName = _this$props6.branchTitleClassName,
          setNodePopoverTips = _this$props6.setNodePopoverTips,
          setNodePopoverProps = _this$props6.setNodePopoverProps,
          mode = _this$props6.mode;
      var labelFieldName = fieldNames.labelFieldName;
      var selectValue = '';
      var selectComponentProps = {};
      var searchValueData = [];

      if (isArray(value)) {
        selectValue = value;
      } else if (typeof value === 'number' || value) {
        selectValue = [value];
      }

      if (!propsSearchValueData) {
        selectComponentProps = {
          SelectionDataComponent: _SelectionDataComponent["default"],
          SelectionDataComponentProps: {
            unrelated: unrelated,
            isAutoCheckedParent: isAutoCheckedParent,
            setNodeClassName: setNodeClassName,
            setBranchTitle: setBranchTitle,
            setNodePopoverTips: setNodePopoverTips,
            setNodePopoverProps: setNodePopoverProps,
            branchTitleClassName: branchTitleClassName,
            valueType: valueType,
            selectTarget: selectTarget,
            canSelected: canSelected,
            TreeProps: TreeProps,
            onColumnScroll: onColumnScroll,
            loadingIds: loadingIds,
            expandNodeIds: expandNodeIds,
            onNodeClick: onNodeClick
          }
        };
      } else {
        if (labelFieldName) {
          propsSearchValueData.map(function (item) {
            if (item) {
              searchValueData.push(_objectSpread({}, item, {
                label: item[labelFieldName] || item.label || ''
              }));
            }

            return item;
          });
        } else {
          searchValueData = propsSearchValueData;
        }
      }

      if (valueAreaType !== 'labels' && !mode) {
        selectComponentProps.ValueAreaComponent = ValueAreaComponent;
      }

      return _react["default"].createElement("div", (0, _spauiUtils.globalProps)(this.props, {
        className: (0, _classnames["default"])('spaui-select-tree', {
          'with-search': search
        })
      }), _react["default"].createElement(_spauiSelect["default"], _extends({
        mode: mode,
        placeholder: placeholder,
        valueDataMap: this.getValueDataMap(),
        clearable: clearable,
        clear: clear,
        onClear: this.handleClear
      }, SelectProps, {
        multiple: multiple,
        disabled: disabled,
        value: selectValue,
        valueLabel: this.getValueLabel(),
        data: data,
        onChange: this.handleChange,
        valueAreaType: valueAreaType
      }, selectComponentProps, {
        dropStyle: dropStyle,
        search: search,
        searchValue: searchValue,
        onSearch: onSearch,
        searchValueData: searchValueData,
        useSearchValueData: search,
        mountTarget: mountTarget,
        mountTargetClassName: mountTargetClassName,
        fieldNames: fieldNames
      })));
    }
  }]);

  return SelectTree;
}(_react.PureComponent);

_defineProperty(SelectTree, "propTypes", {
  placeholder: _spauiUtils.PropTypes.string,
  data: _spauiUtils.PropTypes.array.isRequired,
  value: _spauiUtils.PropTypes.oneOfType([_spauiUtils.PropTypes.array, _spauiUtils.PropTypes.number, _spauiUtils.PropTypes.string]).isRequired,
  onChange: _spauiUtils.PropTypes.func.isRequired,
  setValueLabel: _spauiUtils.PropTypes.func,
  showParentNodeLabel: _spauiUtils.PropTypes.bool,
  delimiter: _spauiUtils.PropTypes.string,
  valueDelimiter: _spauiUtils.PropTypes.string,
  multiple: _spauiUtils.PropTypes.bool,
  disabled: _spauiUtils.PropTypes.bool,
  SelectProps: _spauiUtils.PropTypes.object,
  TreeProps: _spauiUtils.PropTypes.object,
  dropStyle: _spauiUtils.PropTypes.object,
  valueType: _spauiUtils.PropTypes.string,
  unrelated: _spauiUtils.PropTypes.bool,
  setNodeClassName: _spauiUtils.PropTypes.func,
  setBranchTitle: _spauiUtils.PropTypes.func,
  setNodePopoverTips: _spauiUtils.PropTypes.func,
  setNodePopoverProps: _spauiUtils.PropTypes.func,
  branchTitleClassName: _spauiUtils.PropTypes.string,
  isAutoCheckedParent: _spauiUtils.PropTypes.bool,
  selectTarget: _spauiUtils.PropTypes.string,
  search: _spauiUtils.PropTypes.bool,
  searchValue: _spauiUtils.PropTypes.string,
  searchValueData: _spauiUtils.PropTypes.array,
  labelData: _spauiUtils.PropTypes.array,
  onSearch: _spauiUtils.PropTypes.func,
  canSelected: _spauiUtils.PropTypes.func,
  valueAreaType: _spauiUtils.PropTypes.string,
  clearable: _spauiUtils.PropTypes.bool,
  clear: _spauiUtils.PropTypes.bool,
  expandNodeIds: _spauiUtils.PropTypes.array,
  onNodeClick: _spauiUtils.PropTypes.func,
  onColumnScroll: _spauiUtils.PropTypes.func,
  ValueAreaComponent: _spauiUtils.PropTypes.oneOfType([_spauiUtils.PropTypes.element, _spauiUtils.PropTypes.func]),
  loadingIds: _spauiUtils.PropTypes.array,
  mountTarget: _spauiUtils.PropTypes.oneOfType([_spauiUtils.PropTypes.string, _spauiUtils.PropTypes.object]),
  mountTargetClassName: _spauiUtils.PropTypes.string,
  fieldNames: _spauiUtils.PropTypes.shape({
    labelFieldName: _spauiUtils.PropTypes.string,
    titleFieldName: _spauiUtils.PropTypes.string,
    disabledFieldName: _spauiUtils.PropTypes.string,
    nodeFieldName: _spauiUtils.PropTypes.string,
    descriptionFieldName: _spauiUtils.PropTypes.string
  })
});

_defineProperty(SelectTree, "defaultProps", {
  placeholder: '请选择',
  showParentNodeLabel: true,
  data: [],
  delimiter: '/',
  valueDelimiter: ', ',
  value: '',
  multiple: false,
  disabled: false,
  SelectProps: {},
  TreeProps: {
    className: 'spaui-level'
  },
  dropStyle: {},
  valueType: 'parent',
  unrelated: false,
  setNodeClassName: function setNodeClassName() {
    return '';
  },
  branchTitleClassName: '',
  isAutoCheckedParent: true,
  selectTarget: 'default',
  search: false,
  searchValue: '',
  labelData: [],
  valueAreaType: 'string',
  clear: false,
  ValueAreaComponent: _ValueAreaComponent["default"],
  loadingIds: [],
  fieldNames: _objectSpread({}, defaultFieldNames, {
    descriptionFieldName: 'infomation',
    popoverTipsFieldName: 'popoverTips'
  })
});

var _default = SelectTree;
exports["default"] = _default;